<template>
  <modal
    v-model="localShow"
    :title="modalTitle"
    size="lg"
  >
    <div v-if="hasNoCriteria" class="empty-state">
      <p>No review criteria available for this profile.</p>
    </div>

    <div v-else>
      <div
        v-for="section in criteriaSections"
        :key="section.type"
      >
        <div class="modal-subtitle-section">
          <p class="modal-subtitle">{{ section.subtitle }}</p>
        </div>
        <div class="criteria-sections">
          <div
            v-for="(criterion, index) in section.criteria"
            :key="section.type + '-' + index"
            :data-section="section.type"
            class="criterion-item"
          >
            <div class="criterion-header">
              <h4 class="criterion-title">{{ criterion.label }}</h4>
            </div>
            <p class="criterion-description">{{ criterion.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer">
      <button class="btn btn-lg btn-default" @click="close">
        Cancel
      </button>
      <button class="btn btn-lg ai-bg" @click="handleReview">
        <span class="material-icons-outlined" aria-hidden="true">assignment_turned_in</span>
        <span>Review Goal & Objectives</span>
      </button>
    </div>
  </modal>
</template>

<script>
import { isCriteriaForGrade, isCriteriaForSubjects } from '@/util/goals'
export default {
  name: 'AutoReviewModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    criteriaSetName: {
      type: String,
      default: ''
    },
    criteriaByType: {
      type: Object,
      default: null
    },
    goalGrades: {
      type: Array,
      default: () => []
    },
    goalSubjects: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localShow: this.isOpen
    }
  },
  watch: {
    isOpen(newVal) {
      this.localShow = newVal
    },
    localShow(newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    }
  },
  computed: {
    modalTitle() {
      return this.criteriaSetName
        ? `Auto-review (${this.criteriaSetName})`
        : 'Auto-review'
    },
    criteriaSections() {
      if (!this.criteriaByType) {
        return []
      }

      const sections = []

      if (this.criteriaByType.goals && this.criteriaByType.goals.length > 0) {
        sections.push({
          type: 'goals',
          subtitle: 'Review annual goal according to the following criteria set:',
          criteria: this.criteriaByType.goals.filter(criterion => isCriteriaForGrade(criterion, this.goalGrades) || isCriteriaForSubjects(criterion, this.goalSubjects))
        })
      }

      if (this.criteriaByType.objectives && this.criteriaByType.objectives.length > 0) {
        sections.push({
          type: 'objectives',
          subtitle: 'Review objectives according to the following criteria set:',
          criteria: this.criteriaByType.objectives.filter(criterion => isCriteriaForGrade(criterion, this.goalGrades) || isCriteriaForSubjects(criterion, this.goalSubjects))
        })
      }

      return sections
    },
    hasNoCriteria() {
      return !this.criteriaByType || this.criteriaSections.length === 0
    }
  },
  methods: {
    close() {
      this.localShow = false
    },
    handleReview() {
      this.$emit('review')
      this.close()
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .modal-body {
  max-height: 65vh;
  overflow-y: auto;
  padding: 0;
}

/deep/ .modal-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
}

/deep/ .modal-header {
  border-bottom: none;
}

.modal-subtitle-section {
  background: #f1f1f1;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  padding: 12px 20px;
}

.modal-subtitle {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #333;
  margin: 0;
}

.empty-state {
  padding: 40px 20px;
  text-align: center;
  color: #333;
}

.criteria-sections {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 12px;
}

.criterion-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  border-bottom: 1px solid #ccc;

  &:last-child {
    border-bottom: none;
  }
}

.criterion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.criterion-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #333;
  margin: 0;
}

.criterion-description {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #6f6f6f;
  margin: 0;
}

.ai-bg {
  color: #FFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: none;
  &:hover {
    background: var(--AI-AI-Blue-Pink-Hover);
  }
  &:focus-visible {
    outline-offset: 2px;
    outline: 2px solid var(--AI-Blue);
  }
}
</style>
